/* Novaris desktop quick-add behavior.
 * Normal product cards use Impulse native Quick Shop.
 * Variant-expanded collection cards add the exact represented variant directly.
 * Desktop only. Mobile remains untouched.
 * v55: each small product-cart icon mirrors the quantity currently in cart.
 */
(function () {
  'use strict';
  if (window.NovarisDesktopQuickAdd) return;
  window.NovarisDesktopQuickAdd = true;
  var mq = window.matchMedia('(min-width: 769px)');

  function isDesktop() {
    return mq.matches;
  }

  // v65: secondary product images stay dormant until the customer actually
  // hovers/focuses a desktop card. This prevents dozens of unused hover images
  // from competing with the primary catalog images for bandwidth.
  function loadDeferredHoverImage(card) {
    if (!isDesktop() || !card || !card.querySelector) return;
    var image = card.querySelector('.nv-deferred-hover-image');
    if (!image || image.getAttribute('data-nv-hover-loaded') === 'true') return;
    image.setAttribute('data-nv-hover-loaded', 'true');
    image.classList.add('lazyload');
    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
      window.lazySizes.loader.unveil(image);
    }
  }

  var lastKnownCart = null;
  var cartRequest = null;

  function cartJsonRoute() {
    if (window.theme && theme.routes && theme.routes.cart) return theme.routes.cart;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function quantityMaps(cart) {
    var products = Object.create(null);
    var variants = Object.create(null);
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    items.forEach(function (item) {
      var qty = Math.max(0, Number(item.quantity) || 0);
      var productId = String(item.product_id || '');
      var variantId = String(item.variant_id || item.id || '');
      if (productId) products[productId] = (products[productId] || 0) + qty;
      if (variantId) variants[variantId] = (variants[variantId] || 0) + qty;
    });

    return { products: products, variants: variants };
  }

  function syncQuickAddQuantities(cart) {
    if (!isDesktop() || !cart) return;
    lastKnownCart = cart;
    var maps = quantityMaps(cart);

    document.querySelectorAll('.nv-desktop-quickadd').forEach(function (trigger) {
      var card = trigger.closest && trigger.closest('.grid-product');
      var productId = card && card.getAttribute('data-product-id');
      var variantId = trigger.getAttribute('data-variant-id') || (card && card.classList.contains('nv-grid-variant-card') && card.getAttribute('data-variant-id'));
      var qty = variantId ? (maps.variants[String(variantId)] || 0) : (maps.products[String(productId || '')] || 0);

      trigger.setAttribute('data-nv-cart-qty', String(qty));

      if (!trigger.hasAttribute('data-nv-base-label')) {
        trigger.setAttribute('data-nv-base-label', trigger.getAttribute('aria-label') || 'Carrito');
      }
      var baseLabel = trigger.getAttribute('data-nv-base-label') || 'Carrito';
      trigger.setAttribute('aria-label', qty > 0 ? (baseLabel + ' · ' + qty + (qty === 1 ? ' unidad en el carrito' : ' unidades en el carrito')) : baseLabel);
    });
  }

  function requestCartSync() {
    if (!isDesktop()) return Promise.resolve(null);
    if (cartRequest) return cartRequest;

    cartRequest = fetch(cartJsonRoute(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('No se pudo leer el carrito.');
        return response.json();
      })
      .then(function (cart) {
        syncQuickAddQuantities(cart);
        return cart;
      })
      .catch(function () { return null; })
      .finally(function () { cartRequest = null; });

    return cartRequest;
  }

  function dispatchAddSuccess(data, trigger) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: data,
        addToCartBtn: trigger
      }
    }));
  }

  function dispatchAddError(message) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: { errorMessage: message || 'No se pudo agregar este producto.' }
    }));
  }

  function directAddVariant(trigger) {
    if (!trigger || trigger.getAttribute('aria-busy') === 'true') return;
    var variantId = trigger.getAttribute('data-variant-id');
    if (!variantId) return;

    trigger.setAttribute('aria-busy', 'true');
    trigger.classList.add('btn--loading');

    var body = 'id=' + encodeURIComponent(variantId) + '&quantity=1';
    var route = (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js';

    fetch(route, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status === 422) {
          dispatchAddError(data.description);
          return;
        }
        dispatchAddSuccess(data, trigger);
      })
      .catch(function () {
        dispatchAddError('No se pudo agregar este producto.');
      })
      .finally(function () {
        trigger.removeAttribute('aria-busy');
        trigger.classList.remove('btn--loading');
      });
  }

  document.addEventListener('pointerover', function (event) {
    if (!isDesktop()) return;
    var card = event.target && event.target.closest && event.target.closest('.grid-product');
    if (card) loadDeferredHoverImage(card);
  }, { passive: true });

  document.addEventListener('focusin', function (event) {
    if (!isDesktop()) return;
    var card = event.target && event.target.closest && event.target.closest('.grid-product');
    if (card) loadDeferredHoverImage(card);
  });

  // Direct-add controls live inside the product link to preserve the exact Impulse card layout.
  // Cancel the link click and add the exact variant instead.
  document.addEventListener('click', function (event) {
    if (!isDesktop()) return;
    var trigger = event.target && event.target.closest && event.target.closest('[data-nv-variant-direct-add]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    directAddVariant(trigger);
  });

  // Keyboard accessibility for both native quick-shop and direct variant add controls.
  document.addEventListener('keydown', function (event) {
    if (!isDesktop()) return;
    var trigger = event.target && event.target.closest && event.target.closest('.nv-desktop-quickadd');
    if (!trigger) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    if (!trigger.classList.contains('quick-product__btn--not-ready')) {
      trigger.click();
    }
  });

  // After Shopify confirms the item was added, close only the native quick-shop modal.
  // Direct variant cards do not open a modal, so this listener ignores them.
  document.addEventListener('ajaxProduct:added', function (event) {
    if (!isDesktop()) return;

    // Read the resulting cart so the badge reflects the real cumulative qty,
    // including quantities chosen inside native Quick Shop.
    window.setTimeout(requestCartSync, 60);

    var button = event.detail && event.detail.addToCartBtn;
    if (!button || !button.closest) return;
    var modal = button.closest('.modal--quick-shop');
    if (!modal) return;

    window.setTimeout(function () {
      var close = modal.querySelector('.js-modal-close');
      if (close) close.click();
    }, 180);
  });

  document.addEventListener('cart:updated', function (event) {
    if (!isDesktop()) return;
    var cart = event.detail && event.detail.cart;
    if (cart) syncQuickAddQuantities(cart);
    else requestCartSync();
  });

  document.addEventListener('recommendations:loaded', function () {
    if (!isDesktop()) return;
    if (lastKnownCart) syncQuickAddQuantities(lastKnownCart);
    else requestCartSync();
  });

  document.addEventListener('shopify:section:load', function () {
    if (!isDesktop()) return;
    if (lastKnownCart) syncQuickAddQuantities(lastKnownCart);
    else requestCartSync();
  });

  // Initial state: if the visitor already has items in the cart, show the
  // corresponding per-product quantity as soon as desktop cards are ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestCartSync, { once: true });
  } else {
    requestCartSync();
  }
})();
